<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Chuyên ngành: {{ modelData.name }}</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="12">
          <el-form label-position="left" :model="modelData" ref="createModel" label-width="180px" @submit.native.prevent>
            <el-form-item label="Chuyên ngành:" class="form-item">
              <span>{{ modelData.name }}</span>
            </el-form-item>
            <el-form-item label="Mã:" class="form-item">
              <span>{{ modelData.code }}</span>
            </el-form-item>
            <el-form-item label="Kích hoạt:">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                disabled
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
export default {
  name: 'PromotionShow',
  metaInfo () {
    return {
      title: 'Chuyên ngành'
    }
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        code: '',
        discount: '',
        date_start: '',
        date_end: '',
        title: '',
        description: '',
        status: true
      },
      configData: {
        level: {
          id: 0,
          name: 'Tên khóa này'
        },
        facult: {
          id: 0,
          name: 'Tên khóa này'
        }
      }
    }
  },
  mounted () {
    this.configDataAndBreadcrumb()
    this.fetchModel()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    configDataAndBreadcrumb () {
      this.modelData.level_id = this.$route.params.level_id
      this.fetchCourse()
    },
    fetchCourse () {
      axios.get('levels/' + this.$route.params.level_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.configData.level = response.data
            this.fetchFacult()
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchFacult () {
      axios.get('facults/' + this.$route.params.facult_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.configData.facult = response.data
            this.configBreadcrumb()
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'levels-index', text: 'Hệ đào tạo' },
        { name: 'levels-show', text: this.configData.level.name, level_id: this.$route.params.level_id },
        { name: 'facults-show', text: this.configData.facult.name, level_id: this.$route.params.level_id, facult_id: this.$route.params.facult_id },
        { name: 'specializeds-create', text: 'Xem chi tiết' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'levels-show', params: {level_id: this.$route.params.level_id}})
      // this.$router.push({name: 'specializeds-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('specializeds/' + this.$route.params.specialized_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/specializeds/Show.vue